module.exports = __webpack_public_path__ + "static/img/adressC.49da9b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/adressC.png
// module id = r95F
// module chunks = 1